// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"5f2f3fb7","726":"92cd3fe1","785":"59d374cd"}[chunkId] + ".chunk.js";
};